import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import FormatListBulletedSharpIcon from "@mui/icons-material/FormatListBulletedSharp";
import { Button, Grid2 } from "@mui/material";
import { ColDef, EditableCallbackParams } from "ag-grid-community";
import React from "react";
import { Profile } from "../../../models/Profile";

type Props = {
	setProfileId: (profile: Profile) => void;
	setModalProceduresProfile: (showModal: boolean) => void;
	setModalDeleteProfile: (showModal: boolean) => void;
	showContextMenu: Function;
};

export const useTableData = ({
	setProfileId,
	setModalProceduresProfile,
	setModalDeleteProfile,
	showContextMenu,
}: Props) => {
	const columnDefs: ColDef[] = [
		{
			field: "ProfileName",
			headerName: "Profile name",
			minWidth: 170,
			flex: 2,
			cellStyle: {
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			},
		},
		{
			field: "Actions",
			cellRenderer: (params: EditableCallbackParams) => {
				return (
					<Grid2
						container
						sx={{
							height: "100%",
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							opacity: 0,
							transition: "opacity 0.1s ease-in-out",
							".ag-row-hover &": {
								opacity: 1,
							},
							".ag-row-focus &": {
								opacity: 1,
							},
							".ag-row-selected &": {
								opacity: 1,
							},
						}}
					>
						<Grid2
							size={{ xs: 12, md: 12 }}
							style={{
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
							}}
						>
							<Button
								onClick={() => {
									(async () => {
										setProfileId(params?.data as Profile);
										setModalProceduresProfile(true);
									})();
								}}
							>
								<EditIcon color="primary" />
							</Button>
							<Button
								onClick={() => {
									(async () => {
										setProfileId(params.data as Profile);
										setModalDeleteProfile(true);
									})();
								}}
							>
								<DeleteIcon color="secondary" />
							</Button>
							<Button
								style={{}}
								onClick={(e) =>
									showContextMenu(e, params.data, "TableProfiles")
								}
							>
								<FormatListBulletedSharpIcon
									style={{ height: "auto" }}
									color="action"
								/>
							</Button>
						</Grid2>
					</Grid2>
				);
			},
			headerName: " ",
			wrapText: false,
			autoHeight: false,
			wrapHeaderText: false,
			sortable: false,
			flex: 2,
			minWidth: 300,
		},
	];

	return { columnDefs };
};
